export default __webpack_public_path__ + "static/media/56@3x.8b23337d.png";